// services/webhookService.ts

/** API base: same-origin in browser (Vite proxies /api → :4000). Override with VITE_API_URL if needed. */
export const getWebhookApiBase = (): string => {
    const envBase = (import.meta as any).env?.VITE_API_URL;
    if (envBase) return String(envBase).replace(/\/$/, '');
    if (typeof window !== 'undefined') return '';
    return 'http://localhost:4000';
};

const buildN8nPayload = (trigger: string, context: any) => ({
    event: trigger,
    timestamp: new Date().toISOString(),
    context,
});

/** Sends events to the API server, which forwards to n8n (env URL, registered bridges, then master). */
export const notifyN8nEvent = async (trigger: string, context: any) => {
    const apiBase = getWebhookApiBase();
    const payload = buildN8nPayload(trigger, context);
    console.log(`[n8n] Notify ${trigger}`);
    try {
        const res = await fetch(`${apiBase}/api/n8n/notify`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        });
        if (!res.ok) {
            const text = await res.text().catch(() => '');
            console.warn(`[n8n] notify responded ${res.status}:`, text);
        }
    } catch (err: any) {
        console.warn(`[n8n] notify failed for ${trigger}:`, err?.message || err);
    }
};

function resolveApiBase(): string {
    return (
        (import.meta as any).env?.VITE_API_URL ||
        (typeof window !== 'undefined' && window.location.hostname !== 'localhost' ? '' : 'http://localhost:4000')
    );
}

/**
 * POST naar n8n/webhook: eerst via Node `/api/proxy-webhook` (geen CORS).
 * Als de proxy 404 geeft (statische hosting zonder server), direct naar `webhookUrl` (n8n staat CORS vaak toe).
 */
export async function postWebhookProxyOrDirect(webhookUrl: string, payload: Record<string, unknown>): Promise<Response> {
    const apiBase = resolveApiBase();
    const proxyUrl = `${apiBase}/api/proxy-webhook`;

    try {
        const res = await fetch(proxyUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ url: webhookUrl, payload }),
        });
        if (res.ok) return res;
        if (res.status === 404 || res.status === 405) {
            console.warn(`[webhook] Proxy niet bereikbaar (${res.status}), direct POST naar n8n…`);
        } else {
            return res;
        }
    } catch (e: any) {
        console.warn('[webhook] Proxy-fetch mislukt, direct POST naar n8n…', e?.message || e);
    }

    return fetch(webhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        mode: 'cors',
    });
}

export const dispatchGlobalWebhook = (trigger: string, context: any) => {
    void notifyN8nEvent(trigger, context);
};
